import { get } from 'lodash';

const styles = ({ color, fontSize, typography }) => ({

  saveButton: {
    marginBottom: 10,
    '&:focus': {
      backgroundColor: get(color, 'borderColor'),
    },
  },
  closeButton: {
    marginBottom: 10,
    marginLeft: 10,
    '&:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
    },
  },
  addCertPanel: {
    width: 600,
  },
  sectionTitle: {
    marginTop: 56,
  },
  notificationWidthClass: {
    width: '30%',
    padding: '0 15px',
    marginLeft: -10,
    marginTop: 42,
  },
  dialogButtonPanel: {
    marginLeft: 'auto',
  },
  assistText: {
    color: `${get(color, 'bodyText')} !important`,
    fontFamily: `${get(typography, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'smallText')} !important`,
    width: '50%',
  },
  footer: {
    display: 'flex',
    marginTop: 40,
  },
});

export default styles;
